import axios from 'axios';
import {
  ICardIdData,
  IConsultantData,
  IConsultantServiceData,
  IConsultantSubData,
  IFetchConsultantData,
  IFullAppointmentData,
} from '../interfaces';

const checkoutBaseUrl = process.env.REACT_APP_CHECKOUT_BASE_URL;
const consultantBaseUrl = process.env.REACT_APP_CONSULTANT_BASE_URL;

async function createCreditCardOrder(
  consultantServiceData: IConsultantServiceData,
  cardToken: string
): Promise<string> {
  const response = await axios.post(
    `${checkoutBaseUrl}checkoutConsultantService/credit-card-order`,
    { consultantServiceData, cardToken }
  );
  return response.data;
}

async function createPixOrder(
  consultantServiceData: IConsultantServiceData
): Promise<{ QR_CODE: string; transactionId: string }> {
  const response = await axios.post(`${checkoutBaseUrl}checkoutConsultantService/pix-order`, {
    consultantServiceData,
  });
  return response.data;
}

async function checkPaymentStatus(customerAppointmentId: number): Promise<boolean> {
  try {
    const response = await axios.get(
      `${checkoutBaseUrl}checkoutConsultantService/check-payment-status/${customerAppointmentId}`
    );
    return response.data.transactionPaid;
  } catch (e) {
    return false;
  }
}

async function getConsultantCheckoutInfo(token: string): Promise<IFetchConsultantData> {
  const response = await axios.get(`${consultantBaseUrl}profile/consultant-checkout-info`, {
    headers: {
      authorization: token,
    },
  });

  return response.data;
}

async function getConsultantCardsIds(token: string): Promise<ICardIdData[]> {
  const response = await axios.get(`${checkoutBaseUrl}consultant-billing/billings`, {
    headers: { authorization: token },
  });

  return response.data;
}

async function createConsultantAndCardId(
  consultantData: IConsultantData,
  cardToken: string,
  token: string
): Promise<string> {
  const response = await axios.post(
    `${checkoutBaseUrl}consultant-billing/consultant-card-id`,
    { consultantData, cardToken },
    {
      headers: { authorization: token },
    }
  );
  return response.data;
}

async function deleteConsultantCardId(billingId: number, token: string): Promise<void> {
  await axios.delete(`${checkoutBaseUrl}consultant-billing/remove-card/${billingId}`, {
    headers: { authorization: token },
  });
}

async function createConsultantSubscriptionPlan(
  subscriptionData: IConsultantSubData,
  billingId: number,
  token: string
): Promise<string> {
  const response = await axios.post(
    `${checkoutBaseUrl}consultantPlans/subscription-plan`,
    { subscriptionData, billingId },
    {
      headers: { authorization: token },
    }
  );
  return response.data;
}

async function getAppointmentCheckoutData(customerAppointmentId): Promise<IFullAppointmentData> {
  const response = await axios.get(
    `${consultantBaseUrl}appointment/checkoutAppointmentInfo/${customerAppointmentId}`
  );

  return response.data;
}

export const apiCheckoutConsultant = {
  createCreditCardOrder,
  createPixOrder,
  checkPaymentStatus,
  getConsultantCheckoutInfo,
  getConsultantCardsIds,
  createConsultantAndCardId,
  deleteConsultantCardId,
  createConsultantSubscriptionPlan,
  getAppointmentCheckoutData,
};
